import { centralSceneValues } from '@app/lib/Scenes/centralSceneValues'

const getWallmoteButtonStates = (wallmoteSettings, dataNumber) => {
  const valuesArray = wallmoteSettings.find((el) => el.button_number === dataNumber).press_settings
  return valuesArray.map((number) => centralSceneValues.find((currentValue) => currentValue.value === number))
}

export default getWallmoteButtonStates
